import { connect } from 'react-redux';
import SignIn from './SignIn';

import { setSignInIsVisible } from './actions';
import { signInFunc, setEmail, setPassword, clearAuthError } from '../../common/auth/actions';


const mapStateToProps = state => ({
    isVisible: state.signInUI.isVisible,
    authError: state.auth.authError,
    email: state.auth.authEmail,
    password: state.auth.password,
    authToken: state.auth.authToken,
});

const mapDispatchToProps = dispatch => ({
    signIn: (email, password) => dispatch(signInFunc(email, password)),
    setSignInIsVisible: isVisible => dispatch(setSignInIsVisible(isVisible)),
    setEmail: email => dispatch(setEmail(email)),
    setPassword: password => dispatch(setPassword(password)),
    clearAuthError: () => dispatch(clearAuthError(null)),
});


export default connect(mapStateToProps, mapDispatchToProps)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignIn/index.js